import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import GalleryLightbox from '../components/GalleryLightbox';
import { COMPANY } from '../data/seedData';
import { imageUrl } from '../lib/images';

export default function PumpebrondeTankePage() {
  const brochurePdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/brochure-pumpebroend.pdf';

  return (
    <>
      <SeoHead
        title="Pumpebrønde & tanke - RB Glasfiber A/S"
        description="RB Glasfiber producerer pumpebrønde i glasfiber samt indstøbningsbrønde, dobbeltvægget tanke og brøndtoppe. Kemikalieresistent vinylester og høj holdbarhed."
        canonical="https://www.rb-glasfiber.dk/rb-glasfiber/pumpebronde-amp-tanke"
        ogImage="https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-pumpebroend-glasfiber-thumb1-cropresize-550x413.webp"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-pumpebroend-glasfiber-thumb1-cropresize-550x413.webp', 'width=1600,quality=80,format=auto')}
            alt="Pumpebrønde & tanke"
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-water"></i>
              <span>Forsyning & Industri</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-6">
              Pumpebrønde & tanke
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              RB Glasfiber producerer pumpebrønde i glasfiber samt indstøbningsbrønde, dobbeltvægget tanke og brøndtoppe.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href={brochurePdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded bg-[#1e9457] hover:bg-[#15703f] text-white font-bold uppercase tracking-wider text-sm shadow transition-all"
              >
                <i className="fa-solid fa-file-pdf"></i>
                <span>Download datablad (PDF)</span>
              </a>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm border border-slate-700 transition-all"
              >
                <span>Få et tilbud på din brønd</span>
                <i className="fa-solid fa-arrow-right text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Sections */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {/* Section 1: Pumpebrønde */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7 space-y-4">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Høj kemikalieresistens & fleksibilitet
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Pumpebrønde i glasfiber
              </h2>
              <p className="text-slate-700 text-base leading-relaxed">
                RB Glasfiber leverer pumpebrønde fremstillet i glasfiber-armeret polyester, der udmærker sig ved kemikalieresistens (i form af et barriere lag af vinylester), korrosionsbestandighed, vedligeholdelsesfrit mv. Pumpebrønde er beregnet til at pumpe f.eks. regnvand og kloakvand videre til rensningsanlæg.
              </p>
              <p className="text-slate-700 text-base leading-relaxed">
                RB pumpebrønde leveres i 9 forskellige størrelser fra Ø 800 til 3000 mm. En prisbillig løsning med stor fleksibilitet og med rig mulighed for speciallevering ved tilvalg af f.eks. fundament, topkegle, mellemdæk, topdæk mv. Rørgennemføringer efter tegning. Andre størrelser kan leveres efter ønske.
              </p>
              <div className="pt-2">
                <a
                  href={`tel:${COMPANY.phoneRaw}`}
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#1e9457] hover:text-[#15703f]"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Ring og hør nærmere på {COMPANY.phone}</span>
                </a>
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-[4/3] bg-slate-900">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-pumpebroend-glasfiber-thumb1-cropresize-550x413.webp', 'width=700,quality=85,format=auto')}
                  alt="RB Glasfiber pumpebrønd"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Section 2: Indstøbningsbrønde */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center pt-8 border-t border-slate-200">
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-[4/3] bg-slate-900">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/indstoebningsbroend2-cropresize-500x375.webp', 'width=700,quality=85,format=auto')}
                  alt="Indstøbningsbrønde i glasfiber"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="lg:col-span-7 space-y-4 order-1 lg:order-2">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Renovering af betonbrønde
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Indstøbningsbrønde
              </h2>
              <p className="text-slate-700 text-base leading-relaxed">
                RB Glasfiber producerer indstøbningsbrønde i glasfiber, som fungerer som en indsats til gamle eller nedslidte pumpebrønde i beton. Vi producerer vores indstøbingsbrønde med et barriere-lag i vinylester, som er et særdeles kemikalie resistent produkt.
              </p>
              <p className="text-slate-700 text-base leading-relaxed">
                Indstøbningsbrønden produceres, så den passer til den pågældende betonbrønd, dog en anelse mindre, så den let kan monteres og støbes fast i den eksisterende brønd.
              </p>
            </div>
          </div>

          {/* Section 3: Dobbeltvægget tanke & varianter */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center pt-8 border-t border-slate-200">
            <div className="lg:col-span-7 space-y-4">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Miljøsikring mod udslip
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Dobbeltvægget tanke & beholdere
              </h2>
              <p className="text-slate-700 text-base leading-relaxed">
                Ved at vælge en tank med dobbelt vægge, vil væsken ikke løbe ud i naturen, hvis den inderste væg skulle blive utæt. I så fald, vil væsken samle sig mellem de to vægge. Også her støbes et barriere lag af vinylester ind i væggene, som ekstra kemikaliesikring.
              </p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-4 text-xs font-semibold text-slate-800">
                <div className="p-3 bg-slate-50 border border-slate-200 rounded">
                  <i className="fa-solid fa-check text-[#1e9457] mr-1"></i> Dobbeltvægget tank
                </div>
                <div className="p-3 bg-slate-50 border border-slate-200 rounded">
                  <i className="fa-solid fa-check text-[#1e9457] mr-1"></i> Doseringstank
                </div>
                <div className="p-3 bg-slate-50 border border-slate-200 rounded">
                  <i className="fa-solid fa-check text-[#1e9457] mr-1"></i> Trailer-tank
                </div>
                <div className="p-3 bg-slate-50 border border-slate-200 rounded">
                  <i className="fa-solid fa-check text-[#1e9457] mr-1"></i> Mindre tank
                </div>
                <div className="p-3 bg-slate-50 border border-slate-200 rounded">
                  <i className="fa-solid fa-check text-[#1e9457] mr-1"></i> Ø2000 & Ø3000 brønde
                </div>
                <div className="p-3 bg-slate-50 border border-slate-200 rounded">
                  <i className="fa-solid fa-check text-[#1e9457] mr-1"></i> Xylem bund
                </div>
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-[4/3] bg-slate-900">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/dobbelt-tank-2019-scaled-e1581424144496-cropresize-550x413.webp', 'width=700,quality=85,format=auto')}
                  alt="Dobbeltvægget tank"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Technical Data Highlights from Brochure */}
          <div className="p-6 sm:p-8 rounded-xl bg-slate-900 text-white space-y-4">
            <h3 className="text-xl font-bold uppercase tracking-tight text-white flex items-center gap-2">
              <i className="fa-solid fa-circle-info text-[#1e9457]"></i>
              Brochure uddrag: Pumpebrønde specifikationer
            </h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              RB Pumpebrønde leveres som standard i 8 forskellige størrelser fra Ø800 til Ø2500 mm. En økonomisk løsning med stor fleksibilitet og med rig mulighed for speciallevering ved tilvalg af f.eks. fundament, topkegle, mellemdæk, topdæk, rørgennemføringer efter eget valg. RB Pumpebrønde er fremstillet i glasfiber-armeret polyester, der udmærker sig ved kemikalieresistens, korrosionsbestandighed, vedligeholdelsesfri og fleksibilitet.
            </p>
            <div className="pt-2">
              <a
                href={brochurePdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-bold text-[#1e9457] hover:text-[#22c55e] transition-colors"
              >
                <i className="fa-solid fa-download"></i>
                <span>Download fuld brochure (PDF)</span>
              </a>
            </div>
          </div>

          {/* Galleries with Lightbox */}
          <div className="pt-8 border-t border-slate-200">
            <GalleryLightbox
              gallerySlug="pumpebroende"
              title="Fotogalleri: Pumpebrønde og tanke"
              description="Se udvalgte billeder af fremstillede pumpebrønde, Xylem bunde, doseringstanke og trailer-tanke."
              columns={3}
            />
          </div>

          <div className="pt-4">
            <GalleryLightbox
              gallerySlug="indstoebningsbroende"
              title="Fotogalleri: Indstøbningsbrønde"
              description="Eksempler på glasfiberindsatser til brøndrenovering."
              columns={3}
            />
          </div>
        </div>
      </section>
    </>
  );
}
